<script setup lang="ts">
  import { MpText } from '@borg/ui';

  const projectConfig = useProjectConfig();
  const title = projectConfig.title;

  const translationKey = title === 'Vrabotuvanje' ? 'FOOTER_MK' : 'FOOTER';
</script>

<template>
  <div class="site-footer">
    <div class="site-footer__top">
      <BrandLinks />
    </div>
    <div>
      <MpText
        as="p"
        type="body2"
        no-margin
      >
        <Copyright />
      </MpText>
      <MpText
        as="p"
        type="body2"
        no-margin
      >
        {{ $t(`${translationKey}.LINE_1`) }}
      </MpText>
      <MpText
        as="p"
        type="body2"
        no-margin
      >
        {{ $t(`${translationKey}.LINE_2`) }}
      </MpText>
    </div>
  </div>
</template>

<style scoped lang="scss">
  .site-footer {
    display: flex;
    flex-direction: column;
    gap: var(--mp-space-70);

    &__top {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
  }
</style>
